import { ListingType } from '../../../modules/storefront/listingCardCreation/types'
import type { Integrations } from '../../../modules/storefront/types'

export const getIntegrationsByType = (
  integrations: Integrations[],
  type?: ListingType
) => integrations.filter(integration => integration.type === type)
